import * as yup from "yup";

export const vendorSchema = yup.object().shape({
  name: yup
    .string()
    .required()
    .label("Name")
    .transform((value) => value ?? ""),
  email: yup
    .string()
    .email()
    .label("Email")
    .transform((value) => value ?? ""),
  phone: yup
    .string()
    .label("Phone")
    .default("")
    .transform((value) => value ?? ""),
  streetNumber: yup
    .string()
    .label("Street Number")
    .transform((value) => value ?? ""),
  streetName: yup
    .string()
    .label("Street Name")
    .transform((value) => value ?? ""),
  unit: yup
    .string()
    .label("Unit")
    .transform((value) => value ?? ""),
  postalCode: yup
    .string()
    .label("Postal Code")
    .transform((value) => value ?? ""),
  city: yup
    .string()
    .label("City")
    .transform((value) => value ?? ""),
  province: yup
    .string()
    .label("Province")
    .default("ON")
    .transform((value) => value ?? "ON"),
  country: yup
    .string()
    .label("Country")
    .default("CA")
    .transform((value) => value ?? "CA"),
  buzzCode: yup
    .string()
    .label("Buzz Code")
    .transform((value) => value ?? ""),
});
